import { createFileRoute, Outlet, useMatches } from "@tanstack/react-router"
import { useQuery } from "convex/react"
import { CalendarDays, Gamepad2, Hash, ShieldCheck } from "lucide-react"
import { ConsoleSidebar, type ConsoleNavGroup, type ConsoleNavItem } from "@/components/ConsoleSidebar"
import { RoleGate } from "@/lib/role-gate"
import { api } from "../../../convex/_generated/api"

export const Route = createFileRoute("/_authed/host")({
  component: HostShell,
})

const hostNavGroups: ConsoleNavGroup[] = [
  {
    label: "Event workflow",
    items: [
      {
        to: "/host/events",
        label: "Event planning",
        description: "Create + prep",
        icon: CalendarDays,
      },
      {
        to: "/host",
        label: "Event running",
        description: "Live controls",
        icon: Gamepad2,
        exact: true,
        activePrefixes: ["/host/games"],
      },
    ],
  },
  {
    label: "Tools",
    items: [{ to: "/host/magic-numbers", label: "Magic Numbers", icon: Hash }],
  },
]

const adminUtilityItem: ConsoleNavItem = {
  to: "/admin",
  label: "Admin",
  icon: ShieldCheck,
  exact: true,
}

function HostShell() {
  return (
    <RoleGate allowedRoles={["admin", "host"]}>
      <HostShellContent />
    </RoleGate>
  )
}

function HostShellContent() {
  const matches = useMatches()
  const currentPath = matches[matches.length - 1]?.pathname ?? ""
  const me = useQuery(api.auth.getCurrentUser)
  const canAccessAdmin = me?.role === "super_admin" || me?.role === "admin"

  return (
    <ConsoleSidebar
      eyebrow="Host console"
      title="Lyrically Challenged"
      currentPath={currentPath}
      navLabel="Host sections"
      groups={hostNavGroups}
      utilityItems={canAccessAdmin ? [adminUtilityItem] : undefined}
    >
      <Outlet />
    </ConsoleSidebar>
  )
}
